import React, { useEffect } from "react";

import * as M from "./connectModalElement";
import wallet from "assets/wallet.png";

import metamask from "assets//metamask.png";
import {
  loadBlockchain,
  loadWalletConnect,
  updateChainId,
} from "store/redux/slices/web3/connectWeb3Slice";

import { useAppDispatch } from "store/store";
import openNotification from "components/common/toastMessage/toastMessage";

const ConnectModal = () => {
  const dispatch = useAppDispatch();

  const handleWeb3MetaMask = async () => {
    dispatch(loadBlockchain());
  };

  const handleWeb3WalletConnect = async () => {
    dispatch(loadWalletConnect());
  };

  useEffect(() => {
    const subscribeProvider = async () => {
      window.ethereum.on("networkChanged", function (networkId: any) {
        dispatch(updateChainId({ networkId }));
        if( networkId === "1" || networkId === "3" || networkId === "4" || networkId ==="137"){
        }
        else{
          openNotification('Invalid Network', "Please switch to ethereum or polygon network", "warning")
        }
      });
    };
     subscribeProvider();
  }, []);

  return (
    <M.MainModel>
      <M.ModelsData>
        <M.ConnectButton
          onClick={() => handleWeb3MetaMask()}
          className="metamask-btn"
        >
          <M.ConnectIcon src={metamask} alt="icon" />
          Meta Mask
        </M.ConnectButton>

        <M.ConnectButton
          onClick={() => handleWeb3WalletConnect()}
          className="trustwallet-btn"
        >
          <M.ConnectIcon src={wallet} className="trustwallet-btn-img" />
          Wallet Connect
        </M.ConnectButton>
      </M.ModelsData>
    </M.MainModel>
  );
};

export default ConnectModal;
